var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ArrowCircleBrokenUpRightSvg from './arrow-circle-broken-up-right.icon.svg';
export const ArrowCircleBrokenUpRightIcon = (iconInstanceProps) => _jsx(Icon, { ...iconInstanceProps, SvgComponent: ArrowCircleBrokenUpRightSvg });
_react_refresh_temp_1 = ArrowCircleBrokenUpRightIcon;
$RefreshReg$(_react_refresh_temp_1, "ArrowCircleBrokenUpRightIcon");
